import { Alert, AlertIcon } from "@chakra-ui/react";

import { FancyFavicon } from "@/components/fancy-favicon";
import { jobStatusToChakraStatus } from "@/utils/job-status-to-chakra-status";

import { ProcessRunStatusProps } from "./process-run-status";

export function ProcessRunStatusFavicon(props: ProcessRunStatusProps) {
  const { status } = props;

  if (!status) return null;

  const chakraStatus = jobStatusToChakraStatus(status);

  const isInProgress = chakraStatus === "inProgress" || chakraStatus === "loading";

  const isSuccesOrError = chakraStatus === "success" || chakraStatus === "error";

  if (isInProgress || isSuccesOrError)
    return (
      <FancyFavicon isRotating={isInProgress}>
        {isSuccesOrError ? (
          <Alert status={chakraStatus}>
            <AlertIcon />
          </Alert>
        ) : null}
      </FancyFavicon>
    );

  return null;
}
